import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generatePath, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { InterfaceWithId } from "~/common/utils";
import { completeScreening } from "~/patients/api";
import { ROUTES } from "~/patients/router";

export const useCompleteScreening = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: completeScreeningMutation, isPending } = useMutation({
    mutationFn: completeScreening,
    onSuccess: async (data: InterfaceWithId | null) => {
      const path = data
        ? generatePath(ROUTES.startScreening, {
            id: data.id,
          })
        : generatePath(ROUTES.leadPatientHome);
      await queryClient.invalidateQueries({ queryKey: ["getCurrentPatient"] });
      navigate(path);
    },
    onError: () =>
      toast.error(
        "An error occurred while submitting this section. If the issue persists, please refresh the page.",
      ),
  });

  return { completeScreeningMutation, isPending };
};
